export const filters = [
    {
        icon:"none",
        title:"None"
    },
    {
        icon:"Delayed",
        title:"Delayed"
    },
    {
        icon:"Delivered",
        title:"Delivered"
    },
    {
        icon:"Partial",
        title:"Partial"
    },
]